import React, { useEffect, useState } from "react";
import {
    Box,
    Tab,
    Tabs,
} from "@mui/material";
import { Notifications, People } from "@mui/icons-material";
import AppsOutageIcon from '@mui/icons-material/AppsOutage';
import styled from "@emotion/styled";


const AntTabs = styled(Tabs)(({ theme }) => ({
    "& .MuiTabs-indicator": {
        backgroundColor: "#1890ff",
    },
    height: "3.8rem",
    [theme.breakpoints.down("sm")]: {
        height: { xs: "3.5rem" },
        minHeight: { xs: "3.5rem" },
    },
    "& .MuiTabs-scrollButtons": {
        [theme.breakpoints.down("sm")]: {
            width: "30px",
        },
    },
}));


const AntTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: "none",
        minWidth: 0,
        [theme.breakpoints.up("sm")]: {
            minWidth: 0,
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.75rem",
            padding: "6px 8px",
            minheight: { xs: "3.3rem" },
            paddingBottom: "12px", // Add extra bottom padding for mobile
            "& .MuiTab-iconWrapper": {
                marginRight: "4px",
            },
        },
        [theme.breakpoints.down("md")]: {
            fontSize: "0.85rem",
            padding: "8px 12px",
            paddingBottom: "14px", // Add extra bottom padding for tablet
        },
        fontWeight: 700,
        marginRight: theme.spacing(1),
        color: "#005AA6",
        "&:hover": {
            color: "#0A2240",
        },
        "&.Mui-selected": {
            color: "#0A2240",
        },
        "&.Mui-focusVisible": {
            backgroundColor: "#d1eaff",
        },
        position: "relative",
        height: "3.8rem",
        paddingBottom: "10px", // Default bottom padding for desktop
        [theme.breakpoints.down("sm")]: {
            height: "3rem",
        },
    })
);


const TabLabelContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "8px",
    [theme.breakpoints.down("sm")]: {
        gap: "8px",
        fontSize: "0.75rem",
    },
    [theme.breakpoints.down("md")]: {
        gap: "6px",
    },
}));



const StickyTabContainer = styled(Box)(({ theme }) => ({
    position: "sticky",
    top: "50px",
    zIndex: theme.zIndex.appBar - 1,
    backgroundColor: theme.palette.background.paper,
    paddingRight: theme.spacing(2),
    paddingLeft: "1rem",
    height: "3.8rem",
    [theme.breakpoints.down("sm")]: {
        paddingRight: theme.spacing(1),
        paddingLeft: "0.5rem",
        height: { xs: "3.5rem" },
        top: "56px",
    },
    [theme.breakpoints.down("md")]: {
        paddingRight: theme.spacing(1.5),
        paddingLeft: "0.75rem",
    },
}))

const TabNavigation = ({ onChange, selectedTab, features }) => {
    const [tabValue, setTabValue] = useState("alarms");


    useEffect(() => {
        setTabValue(selectedTab);
    }, [selectedTab])


    const handleChange = (event, newValue) => {
        setTabValue(newValue);
        onChange(newValue);
    };


    const createTabWithSearch = (value, label, icon) => {
        const displayLabel = `${label}`;


        return (
            <AntTab
                key={value}
                value={value}
                icon={icon}
                iconPosition="start"
                onClick={() => onChange(value)}
                label={
                    <TabLabelContainer>
                        <span>{displayLabel}</span>
                    </TabLabelContainer>
                }
            />
        );
    };

    return (
        <StickyTabContainer>
            <AntTabs
                value={tabValue}
                onChange={handleChange}
                aria-label="ant example"
                role="navigation"
                TabIndicatorProps={{
                    style: {
                        backgroundColor: "#0A2240",
                        height: "0.2rem",
                    },
                }}
                sx={{
                    backgroundColor: "white",
                    borderRadius: "8px 8px 0 0",
                    "& .MuiTabs-flexContainer": {
                        paddingRight: "16px",
                    },
                }}
            >
                {features.some(f => f.key === "alarms") && createTabWithSearch("alarms", "Alarms", <Notifications fontSize="small" />)}
                {features.some(f => f.key === "outages") && createTabWithSearch("outages", "Outages", <AppsOutageIcon fontSize="small" />)}
                {features.some(f => f.key === "user_counts") && createTabWithSearch("userCounts", "User Counts & Data Usage", <People fontSize="small" />)}
            </AntTabs>
        </StickyTabContainer>
    );
};


export default TabNavigation;